import {Directive, Input, TemplateRef} from '@angular/core';

@Directive({
  selector: '[geecTemplate]',
  host: {}
})
export class GeecTemplateDirective {

  @Input() type: string;

  @Input('geecTemplate') name: string;

  constructor(public template: TemplateRef<any>) {
  }

  getType(): string {
    return this.name;
  }

}
